module.exports = __webpack_public_path__ + "img/google-play-icon.5e01637f.svg";